/* tslint:disable */
/* eslint-disable */
/**
 * Realtime seizure detection
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class MonitoringApi extends runtime.BaseAPI {

    /**
     * Test if application is healthy
     */
    async liveRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/live`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Test if application is healthy
     */
    async live(initOverrides?: RequestInit): Promise<string> {
        const response = await this.liveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Test if application is ready to take requests
     */
    async readyRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ready`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Test if application is ready to take requests
     */
    async ready(initOverrides?: RequestInit): Promise<string> {
        const response = await this.readyRaw(initOverrides);
        return await response.value();
    }

}
